import Logo from "../components/Logo"
import Card from "../components/Card"

function RedirectPage() {
  return (
    <div className="login-container">
          <Logo/>
          <Card>
          <div className="banner redirect-banner "></div>
          <h4 className="card-head"> 
          Success
          </h4>
          <p className="card-text">
          Your Email has been successfully verified, you would be redirected to the sign in page </p>
          </Card>
          
      </div>
  )
}

export default RedirectPage
